import styled from 'styled-components';
import { aspectRatios } from './ThemeCluster.styles';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

type ThemeCarouselBaseStyleProps = {
  $isInitialized?: boolean;
  $totalNumberOfSlides?: number;
  $numberOfSlidesMedium?: number;
  $numberOfSlidesLarge?: number;
  $disablePreviousButton?: boolean;
  $disableNextButton?: boolean;
};

export const MaskItem = styled.div`
  display: none;
  border-radius: ${toRem(15)};

  &:first-child {
    display: flex;
  }

  ${({ $totalNumberOfSlides, $numberOfSlidesMedium }: ThemeCarouselBaseStyleProps) => {
    if (!$totalNumberOfSlides) {
      return '';
    }

    const shouldShowMediumSlideCount = typeof $numberOfSlidesMedium === 'number' ? $numberOfSlidesMedium > 1 : true;

    return (
      $totalNumberOfSlides > 1 &&
      shouldShowMediumSlideCount &&
      `
      @media ${baseVariables.mediaQuery.md} {
        &:nth-child(-n + ${$numberOfSlidesMedium || 2}) {
          display: flex;
        }
      }
    `
    );
  }}

  ${({ $totalNumberOfSlides, $numberOfSlidesLarge }: ThemeCarouselBaseStyleProps) => {
    if (!$totalNumberOfSlides) {
      return '';
    }

    const shouldShowLargeSlideCount = typeof $numberOfSlidesLarge === 'number' ? $numberOfSlidesLarge > 1 : true;

    return (
      $totalNumberOfSlides > 2 &&
      shouldShowLargeSlideCount &&
      `
      @media ${baseVariables.mediaQuery.md} {
        &:nth-child(-n + ${$numberOfSlidesLarge || 3}) {
          display: flex;
        }
      }
    `
    );
  }}

  &.wide {
    aspect-ratio: ${aspectRatios.wide};
  }

  &.tall {
    aspect-ratio: ${aspectRatios.tall};

    &:nth-child(3) {
      display: none;

      @media ${baseVariables.mediaQuery.xl} {
        display: flex;
      }
    }
  }

  &.square {
    aspect-ratio: ${aspectRatios.square};
  }
`;

export const ThemeClusterCarouselMask = styled.div<{ $isVisible?: boolean }>`
  display: flex;
  gap: ${toRem(24)};
  width: 100%;
  ${({ $isVisible }) => ($isVisible === false ? `display: none;` : '')}
`;

export const CarouselMaskWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const MaskOverlay = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  width: 100%;
  z-index: 10;
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease-out, visibility 0s ${({ $isVisible }) => ($isVisible ? '0s' : '0.2s')};
`;

export const CarouselContainer = styled.div<{ $isVisible?: boolean }>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  height: 100%;

  ${({ $isVisible }) =>
    !$isVisible
      ? `
        contain: layout style;
        max-width: 100%;
        overflow: hidden;
      `
      : ''}
  transition: opacity 0.2s ease-in ${({ $isVisible }) => ($isVisible ? '0.15s' : '0s')},
    visibility 0s ${({ $isVisible }) => ($isVisible ? '0.15s' : '0s')};

  .swiper {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }

  .swiper-wrapper {
    max-width: 100%;
    height: 100%;
  }

  .swiper-slide {
    max-width: 100%;
    box-sizing: border-box;
    height: auto;
  }
`;
